import React, { useEffect } from 'react';
import '../AboutStyles/AboutSection.css';

const milestones = [
  { icon: 'bi-folder-check', value: '10+', label: 'Projects' },
  { icon: 'bi-people', value: '10+', label: 'Clients' },
];

const techPillars = [
  { icon: 'bi-display', label: 'Web Apps' },
  { icon: 'bi-phone', label: 'Mobile Apps' },
  { icon: 'bi-receipt', label: 'Billing Engine' },
  { icon: 'bi-headset', label: 'IT Support' },
];

const AboutSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-section-wrap">
      <div className="about-section-inner">
        <div className="about-text-col" data-animate="slideInLeft">
          <h2 className="about-section-heading">
            <span className="about-heading-light">Bellary</span>
            <span className="about-heading-bold"> Info Tech Solutions</span>
          </h2>

          <p className="about-section-para">
            We specialize in developing innovative applications to address billing challenges. Our
            flagship product, the BITS Engine, efficiently generates accurate billing amounts based
            on user-specific criteria. Additionally, we focus on creating seamless mobile apps and
            enhancing user experiences through robust web applications.
          </p>
          <p className="about-section-para">
            We're also pioneers in building smart billing systems and payment solutions that are
            designed to scale with your business needs.
          </p>

          <div className="about-tech-pillars">
            {techPillars.map((t, i) => (
              <div className="about-pillar" key={i}>
                <i className={`bi ${t.icon}`}></i>
                <span>{t.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="about-visual-col" data-animate="slideInRight">
          <div className="about-stats-card">
            <div className="about-stats-header">
              <div className="about-stats-icon">
                <i className="bi bi-building"></i>
              </div>
              <div>
                <h3 className="about-stats-card-title">Company at a Glance</h3>
                <p className="about-stats-card-sub">Bellary Info Tech Solutions</p>
              </div>
            </div>

            <div className="about-milestones-grid">
              {milestones.map((m, i) => (
                <div className="about-milestone" key={i}>
                  <div className="about-milestone-icon">
                    <i className={`bi ${m.icon}`}></i>
                  </div>
                  <span className="about-milestone-value">{m.value}</span>
                  <span className="about-milestone-label">{m.label}</span>
                </div>
              ))}
            </div>

            <div className="about-stats-footer">
              <i className="bi bi-patch-check-fill"></i>
              <span>Trusted partner for digital transformation</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
